import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SideBarTab from '../SideBar/SideBarTab';
import { SideBarInner } from '../../styled-components/SideBar';
import AssetType from '../../constants/assetTypes';
import { actions as assetsActions } from '../../actions/assets';
import { makeGetConfigValue } from '../../selectors/config';
import { generateShortcutText } from '../../util/keyShortcutUtils';
import localize from '../../util/localizeUtils';

const GraphicTemplateImage = 'images/document_add.png';
const CompletedGraphicsImage = 'images/documents.png';
const AutomationImage = 'images/test_card.png';
const StudioClipsImage = 'images/film.png';

const Mousetrap = window.Mousetrap;

class GraphicTemplatesSideBarItem extends SideBarTab {
  render() {
    return <SideBarTab {...this.props} />;
  }
}

class GraphicTemplatesSideBarContent extends React.Component {
  componentDidMount() {
    this.bindShortcuts();
  }

  componentWillUnmount() {
    this.unbindShortcuts();
  }

  bindShortcuts = () => {
    const {
      openGraphicTemplates,
      openCompletedGraphics,
      openAutomation,
      openStudioClips
    } = this.props.shortcuts;
    Mousetrap.bindGlobal(openGraphicTemplates, () =>
      this.props.changeAssetType(AssetType.GRAPHIC_TEMPLATE)
    );
    Mousetrap.bindGlobal(openCompletedGraphics, () =>
      this.props.changeAssetType(AssetType.GRAPHIC_MOS_OBJECT)
    );
    Mousetrap.bindGlobal(openAutomation, () => this.props.changeAssetType(AssetType.AUTOMATION));
    Mousetrap.bindGlobal(openStudioClips, () => this.props.changeAssetType(AssetType.STUDIO_CLIP));
  };

  unbindShortcuts = () => {
    const {
      openGraphicTemplates,
      openCompletedGraphics,
      openAutomation,
      openStudioClips
    } = this.props.shortcuts;
    Mousetrap.unbind(openGraphicTemplates);
    Mousetrap.unbind(openCompletedGraphics);
    Mousetrap.unbind(openAutomation);
    Mousetrap.unbind(openStudioClips);
  };

  render() {
    const {
      changeAssetType,
      currentAssetType,
      showGraphicTemplates,
      showCompletedGraphics,
      showAutomation,
      showStudioClips,
      isModifierActive,
      showOnlyTemplates
    } = this.props;
    return (
      <SideBarInner>
        {showGraphicTemplates ? (
          <GraphicTemplatesSideBarItem
            text={generateShortcutText(localize('graphicTemplatesTab'), isModifierActive)}
            image={GraphicTemplateImage}
            onClick={() => changeAssetType(AssetType.GRAPHIC_TEMPLATE)}
            active={currentAssetType === AssetType.GRAPHIC_TEMPLATE}
          />
        ) : (
          ''
        )}
        {showCompletedGraphics && !showOnlyTemplates ? (
          <GraphicTemplatesSideBarItem
            text={generateShortcutText(localize('completedGraphicsTab'), isModifierActive)}
            image={CompletedGraphicsImage}
            onClick={() => changeAssetType(AssetType.GRAPHIC_MOS_OBJECT)}
            active={currentAssetType === AssetType.GRAPHIC_MOS_OBJECT}
          />
        ) : (
          ''
        )}
        {showAutomation ? (
          <GraphicTemplatesSideBarItem
            text={generateShortcutText(localize('automationTab'), isModifierActive)}
            image={AutomationImage}
            onClick={() => changeAssetType(AssetType.AUTOMATION)}
            active={currentAssetType === AssetType.AUTOMATION}
          />
        ) : (
          ''
        )}
        {showStudioClips ? (
          <GraphicTemplatesSideBarItem
            text={generateShortcutText(localize('studioClipsTab'), isModifierActive)}
            image={StudioClipsImage}
            onClick={() => changeAssetType(AssetType.STUDIO_CLIP)}
            active={currentAssetType === AssetType.STUDIO_CLIP}
          />
        ) : (
          ''
        )}
      </SideBarInner>
    );
  }
}

GraphicTemplatesSideBarContent.defaultProps = {
  showOnlyTemplates: false
};

GraphicTemplatesSideBarContent.propTypes = {
  currentAssetType: PropTypes.string.isRequired,
  changeAssetType: PropTypes.func.isRequired,
  showGraphicTemplates: PropTypes.bool.isRequired,
  showCompletedGraphics: PropTypes.bool.isRequired,
  showAutomation: PropTypes.bool.isRequired,
  showStudioClips: PropTypes.bool.isRequired,
  showOnlyTemplates: PropTypes.bool,
  shortcuts: PropTypes.shape({
    openGraphicTemplates: PropTypes.arrayOf(PropTypes.string),
    openCompletedGraphics: PropTypes.arrayOf(PropTypes.string),
    openAutomation: PropTypes.arrayOf(PropTypes.string),
    openStudioClips: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  isModifierActive: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
  const getConfigValue = makeGetConfigValue();
  return {
    currentAssetType: state.assets.assetType,
    showGraphicTemplates:
      getConfigValue(state, 'userConfig', 'graphicTemplatesDisplay', 'show') === 'show',
    showCompletedGraphics:
      getConfigValue(state, 'userConfig', 'completedGraphicsDisplay', 'show') === 'show',
    showAutomation:
      getConfigValue(state, 'userConfig', 'automationTemplatesDisplay', 'show') === 'show',
    showStudioClips: getConfigValue(state, 'userConfig', 'studioClipsDisplay', 'show') === 'show',
    shortcuts: state.keyShortcuts.shortcuts,
    isModifierActive: state.keyShortcuts.isModifierActive
  };
};

const mapActionCreators = {
  changeAssetType: assetsActions.changeAssetType
};

export default connect(mapStateToProps, mapActionCreators, null, { withRef: true })(
  GraphicTemplatesSideBarContent
);



// WEBPACK FOOTER //
// ./app/components/TemplateSelection/GraphicTemplatesSideBarContent.js